<div class="container">
    <p class="info-message">Notification: application has been successfully processed.</p>
    <p class="support-link"><a href="#">Contact customer support: {{ supportPhoneNumber }}</a></p>
  </div>